import { TChildBirthday, TEventTypes, TGiftPackageType, TWorkAnniversaryGiftVariations } from '../../generated/graphql';

export const getReadableGiftPackageType = (type: string) => {
  switch (type) {
    case TGiftPackageType.EmployeeBirthday:
      return 'Employee Birthday';
    case TGiftPackageType.NewHire:
      return 'New Hire';
    case TGiftPackageType.WorkAnniversary:
      return 'Work Anniversary';
    case TGiftPackageType.SpouseBirthday:
      return 'Significant Other Birthday';
    case TGiftPackageType.ChildBirthday:
      return 'Child Birthday';
    case TGiftPackageType.PetBirthday:
      return 'Pet Birthday';
    case TGiftPackageType.OneOff:
      return 'One Off';
    default:
      return '-';
  }
};

export const getReadableGiftPackageSubType = (subType: string) => {
  switch (subType) {
    // Work Anniversary Gift Variations
    case TWorkAnniversaryGiftVariations.Deluxe:
      return 'Deluxe';
    case TWorkAnniversaryGiftVariations.BrickOnly:
      return 'Brick Only';
    case TWorkAnniversaryGiftVariations.LegoOnly:
      return 'Lego Set';
    case TWorkAnniversaryGiftVariations.Custom:
      return 'Custom';
    case TWorkAnniversaryGiftVariations.Mini:
      return 'Mini';
    // Child Birthday Gift Variations
    case TChildBirthday.Child1:
      return '1 year old';
    case TChildBirthday.Child2:
      return '2 years old';
    case TChildBirthday.Child3:
      return '3 years old';
    case TChildBirthday.Child4:
      return '4 years old';
    case TChildBirthday.Child5:
      return '5 years old';
    case TChildBirthday.Child6:
      return '6 years old';
    case TChildBirthday.Child7:
      return '7 years old';
    case TChildBirthday.Child8:
      return '8 years old';
    case TChildBirthday.Child9:
      return '9 years old';
    case TChildBirthday.Child10to14:
      return 'Ages 10 to 14';
    case TChildBirthday.Child15to18:
      return 'Ages 15 to 18';
    // One Off Gift Variations
    case TEventTypes.BabyGift:
      return 'Baby Gift';
    case TEventTypes.Wedding:
      return 'Wedding/Engagement';
    case TEventTypes.ReplacementWorkAnniversary:
      return 'Replacement Workanniversary';
    case TEventTypes.ReplacementEmployeeBirthday:
      return 'Replacement Employee Birthday';
    case TEventTypes.CarePackage:
      return 'Care Package';
    case TEventTypes.CustomBricks:
      return 'Custom Bricks';
    case TEventTypes.Other:
      return 'Other';
    default:
      return '-';
  }
};
